<div class="forgot-password-area">
  <div class="d-table">
    <div class="d-table-cell">
      <div
        class="daxa-form ml-auto mr-auto border-radius bg-white"
        [class.card-borderd-theme]="themeService.isCardBorder()"
      >
        <div class="title text-center">
          <h3>
            Selección del club o escuela
          </h3>
          <p class="ml-auto mr-auto">
            Enter the email address you used when you joined and we’ll send you instructions to reset your password.
          </p>
        </div>
        <form
          [formGroup]="form"
          novalidate=""
          (ngSubmit)="submit(form)"
        >
          <div class="form-group">
            <!-- <label class="main-label d-block lh-1 text-black">
              Club / Escuela
            </label> -->
            <!-- <mat-form-field>
                <mat-label>
                    Enter email address
                </mat-label>
                <input matInput type="email">
            </mat-form-field> -->
            <mat-form-field>
              <mat-label>Club o escuela</mat-label>
              <mat-select formControlName="organizationId">
                @if (organizationsState) {
                  @for (model of organizationsState.value?.list; track model.id) {
                    <mat-option [value]="model.strId">{{ model.name }}</mat-option>
                  }
                }
              </mat-select>
            </mat-form-field>
          </div>
          <button
            mat-button
            type="submit"
            class="btn"
            [disabled]="form.invalid"
          >
            Seleccionar
          </button>
          <div class="text-center back-to-sign-in">
            <a mat-button routerLink="/">
              <i class="ri-arrow-left-s-line"></i>
              Volver
            </a>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
